import { z } from 'zod';
/** Analytics demo-data slice — the entity inputs the Analytics screen reads beside the shared ledger (`trades()`):
 *  the accounts the trade-log filter chips expose, the journalled session days, the symbol → asset-class map, the armed
 *  playbook and the balance baseline. Transcribed from the design reference (script lines 1040–1051 JRN_DAYS keys,
 *  1451–1455 CMP_ACCOUNTS, anModel() script lines 2068–2646).
 *  Every field is deterministic, seeded and labeled simulated. */
export const AnalyticsLogAccountSchema = z
  .object({
    id: z.string(),
    nickname: z.string(),
    broker: z.string(),
    type: z.string(),
    balance: z.number(),
    colour: z.string(),
    ink: z.string(),
  })
  .strict();
export const AnalyticsDataSchema = z
  .object({
    /** Accounts offered by the trade-log account filter (the reference CMP_ACCOUNTS rows, verbatim). */
    logAccounts: z.array(AnalyticsLogAccountSchema),
    /** ISO day keys of the journal (reference JRN_DAYS keys) — the Behaviour "Journalled days" count. */
    journalDayKeys: z.array(z.string()),
    /** Symbol → asset class; anything unmapped is FX. */
    symbolClasses: z.record(z.string(), z.string()),
    /** The armed playbook the Behaviour tab measures plan adherence against. */
    armedStrategies: z.array(z.string()),
    /** Starting-capital baseline of the account balance overlay. */
    baseCapital: z.number(),
  })
  .strict();
export type AnalyticsData = z.infer<typeof AnalyticsDataSchema>;
export type AnalyticsLogAccount = z.infer<typeof AnalyticsLogAccountSchema>;
